import * as $ from 'jquery';
import { isIOS } from '@fnv-core/utils';

function redirectToSearchPage() {
  let search = $("form.pagebuilder__widget-zoekbalk.form-search:visible").find("input").val();
  location.href = $(".pagebuilder__widget-zoekbalk.form-search").attr("data-url") + "?search=" + search;
}

function redirectToSearchPageFromMenu() {
  let search = $(".nav-item__search .form-search").find("input").val();
  location.href = $(".nav-item__search .form-search").attr("data-url") + "?search=" + search;
}

function initMenu() {

  if ($(".pagebuilder__widget-zoekbalk").length > 0) {
    $(".pagebuilder__widget-zoekbalk.form-search").on("submit", function (event) {
      event.preventDefault();
      redirectToSearchPage();
      return false;
    }); 
  }

  if ($(".nav-item__search").length > 0) {

    $(".nav-item__search .form-search .icon").on("click", function (event) {
      event.preventDefault();
      redirectToSearchPageFromMenu();
      return false;
    }); 

    $(".nav-item__search .form-search").on("submit", function (event) {
      event.preventDefault();
      redirectToSearchPageFromMenu();
      return false;
    }); 
  }

  const inputClickSelector = ".pagebuilder__widget-zoekbalk .filter__search-input + .input-group-append .icon-search";
  if ($(inputClickSelector).length > 0) {
    $(inputClickSelector).off("click");
    $(inputClickSelector).on("click", (event) => {
      event.preventDefault();
      redirectToSearchPage();
      return false;
    });
  }

  $(".navbar-toggler").on('click', function (event) {
    event.preventDefault();

    if ($(".main-navbar").hasClass("main-navbar--mobile-closing")) {
      return;
    }

    if ($(".main-navbar").hasClass("main-navbar--mobile-opening")) {
      return;
    }

    if ($(".navbar-toggler").hasClass("is-active")) {
      
      $(".navbar-toggler").removeClass("is-active");
      $(".navbar-toggler").attr("aria-expanded", "false");
      $(".main-navbar").addClass("main-navbar--mobile-closing");

      setTimeout(function() {
        $(".main-navbar").removeClass("main-navbar--mobile-opened");
        $(".main-navbar").removeClass("main-navbar--mobile-closing");
        $(".main-navbar").removeClass("main-navbar--mobile-moving");
      }, 500);

    } else {
      $(".navbar-toggler").addClass("is-active");
      $(".navbar-toggler").attr("aria-expanded", "true");
      $(".main-navbar").addClass("main-navbar--mobile-opening");

      setTimeout(function() {
        $(".main-navbar").addClass("main-navbar--mobile-opened");
      }, 10);

      setTimeout(function() {
        $(".main-navbar").addClass("main-navbar--mobile-moving");
      }, 25);

      setTimeout(function() {
        $(".main-navbar").removeClass("main-navbar--mobile-opening");
      }, 500);
    }

    return false;
  });


  if (isIOS()) {

    // Store -webkit-tap-highlight-color as this gets set to rgba(0, 0, 0, 0) in the next part of the code
    var tempCSS = $('a').css('-webkit-tap-highlight-color');
    
    $('body').css('cursor', 'pointer')                                    // Make iOS honour the click event on body
              .css('-webkit-tap-highlight-color', 'rgba(0, 0, 0, 0)');     // Stops content flashing when body is clicked
          
    // Re-apply cached CSS
    $('a').css('-webkit-tap-highlight-color', tempCSS);
    

    // The below is a fix for scrolling the body behind a position-fixed overlay
    // Tne positive side-effect is that this also fixes the bug on ios that an overlay can hang
    // after triggering the "momentum scrolling" effect and trying to move the other way
    // (somehow this triggers scrolling the body instead of the overlay)
    (function () { 
      var _overlay = document.getElementById('main-navbar');  
      var _clientY : number = null; // remember Y position on touch start
        
      function isOverlayTotallyScrolled() {           
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions      
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;     
      }
  
      _overlay.addEventListener('touchstart', function (event : TouchEvent) {
        
        if (event.targetTouches.length === 1) {      
          _clientY = event.targetTouches[0].clientY;      
        }
        
      }, false);
        
      function disableRubberBand(event : TouchEvent) {
        
        var clientY = event.targetTouches[0].clientY - _clientY;
        
        if (_overlay.scrollTop === 0 && clientY > 0) {     
          // element is at the top of its scroll     
          event.preventDefault();     
        }
        
        if (isOverlayTotallyScrolled() && clientY < 0) {      
          //element is at the top of its scroll        
          event.preventDefault();      
        }     
      }
        
      _overlay.addEventListener('touchmove', function (event : TouchEvent) {     
        if (event.targetTouches.length === 1) {     
          disableRubberBand(event);     
        }
        
      }, false);
        
    }());
  }

}

export { initMenu };